export default __webpack_public_path__ + "assets/topics-678246c1a7a76821133373abc0af4db1.svg";